import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import SelectedTab from "../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useDispatch } from "react-redux";
import { changeActiveTab } from "../../../slices/hub/informationSlice";
import { resetFormState } from "../../../slices/common/reducer";
import Details from "./Details";

const Information = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.information.tabs);
  const activeTab = useSelector((state) => state.information.activeTab);
  const formState = useSelector((state) => state.common.formRendererState);
  const data = useSelector((state) => state.information.detailsData);

  useEffect(() => {
    return () => {
      dispatch(resetFormState());
      dispatch(changeActiveTab("details"));
    };
  }, [dispatch]);

  const breadcrumbItems = [
    { title: "Hub", link: "" },
    { title: "Information", link: "/hub/information" },
  ];

  const [index, setIndex] = useState(-1);
  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        <Card>
          <div className="details-wrapper">
            <CardHeader>
              <SelectedTab
                tabs={tabs}
                activeTab={activeTab}
                changeActiveTab={changeActiveTab}
              />
            </CardHeader>
            {/* <CardBody> */}
            {/* <div className="selected-tab-bottom-content"> */}
            {activeTab === "details" && <Details />}
            {/* </div> */}
            {/* </CardBody> */}
          </div>
        </Card>
      </div>
    </>
  );
};

export default Information;
